/**
 * Hooks for MVP+: Nutrition Targets & Messaging
 */
import useSWR from "swr";
import { fetcher } from "../lib/api";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// ========== Nutrition Targets ==========
export function useMyNutritionTargets() {
  const { data, error, isLoading, mutate } = useSWR("/api/client/nutrition-targets", fetcher);
  return { targets: data, isLoading, isError: error, mutate };
}

export function useClientNutritionTargets(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/admin/clients/${clientId}/nutrition-targets` : null, fetcher
  );
  return { targets: data, isLoading, isError: error, mutate };
}

export async function setNutritionTargets(clientId, data) {
  return fetcher(`/api/admin/clients/${clientId}/nutrition-targets`, {
    method: "PUT", body: JSON.stringify(data),
  });
}

// ========== Messaging ==========
export function useConversations() {
  const { data, error, isLoading, mutate } = useSWR("/api/messages/conversations", fetcher);
  return { conversations: data || [], isLoading, isError: error, mutate };
}

export function useConversation(partnerId) {
  const { data, error, isLoading, mutate } = useSWR(
    partnerId ? `/api/messages/${partnerId}` : null, fetcher, { refreshInterval: 5000 }
  );
  return { messages: data || [], isLoading, isError: error, mutate };
}

export function useUnreadCount() {
  const { data, mutate } = useSWR("/api/messages/unread/count", fetcher, { refreshInterval: 10000 });
  return { unreadCount: data?.unread_count || 0, mutate };
}

export async function sendMessage(receiverId, content) {
  return fetcher("/api/messages", {
    method: "POST",
    body: JSON.stringify({ receiver_id: receiverId, content }),
  });
}

// ========== Admin Habits CRUD ==========
export async function adminCreateHabit(clientId, data) {
  return fetcher(`/api/admin/clients/${clientId}/habits`, {
    method: "POST", body: JSON.stringify(data),
  });
}

export async function adminDeleteHabit(clientId, habitId) {
  const token = localStorage.getItem("access_token");
  const resp = await fetch(`${API_URL}/api/admin/clients/${clientId}/habits/${habitId}`, {
    method: "DELETE", headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) throw new Error("Erreur suppression habitude");
}
